import React from 'react';

function TextareaComponent({ placeholder, value }) {
    return <textarea className="form-control" placeholder={placeholder} value={value}></textarea>;
}

export default TextareaComponent;
